import { render, staticRenderFns } from "./greetings.vue?vue&type=template&id=20434972"
import script from "./greetings.vue?vue&type=script&lang=js"
export * from "./greetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports